"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const colorProfiles = {
  success: {
    backgroundColor: _BaseTheme.default.colors.green,
    iconColor: _BaseTheme.default.colors.green,
    icon: 'success'
  },
  error: {
    backgroundColor: _BaseTheme.default.colors.red,
    iconColor: _BaseTheme.default.colors.red,
    icon: 'error'
  },
  alert: {
    backgroundColor: _BaseTheme.default.colors.yellow,
    iconColor: _BaseTheme.default.colors.orange,
    icon: 'alert'
  }
};

const AlertWrapper = _styledComponents.default.div.withConfig({
  displayName: "Alert__AlertWrapper",
  componentId: "design-system__w7s3rl-0"
})(["display:", ";background-color:", "52;border:1px solid ", ";padding:0.5rem 0;border-radius:", ";grid-template-columns:5% auto 10%;div{color:", ";font-family:", ";font-size:", ";align-self:center;}button{padding:0;border:0;display:block;background-color:transparent;font-family:", ";color:", ";cursor:pointer;}.icon{align-self:center;justify-self:center;svg{path{fill:", ";}}}"], props => props.hide ? 'none' : 'grid', _ref => {
  let {
    color
  } = _ref;
  return colorProfiles[color].backgroundColor;
}, _ref2 => {
  let {
    color
  } = _ref2;
  return colorProfiles[color].backgroundColor;
}, _BaseTheme.default.radius.regular, _BaseTheme.default.colors.darkgray, _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.small, _BaseTheme.default.type.family.system, _BaseTheme.default.colors.blue, _ref3 => {
  let {
    color
  } = _ref3;
  return colorProfiles[color].iconColor;
});

const Alert = _ref4 => {
  let {
    children,
    onClick,
    hide,
    buttonText,
    type
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(AlertWrapper, {
    hide: hide,
    color: type
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "icon",
    type: colorProfiles[type].icon,
    color: type,
    size: "20"
  }), /*#__PURE__*/_react.default.createElement("div", null, children), !!onClick && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: onClick,
    color: type
  }, buttonText));
};

Alert.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
  onClick: _propTypes.default.func,
  hide: _propTypes.default.bool,
  buttonText: _propTypes.default.string,
  type: _propTypes.default.oneOf(['alert', 'error', 'success'])
};
Alert.defaultProps = {
  onClick: undefined,
  hide: false,
  buttonText: '',
  type: 'alert'
};
var _default = Alert;
exports.default = _default;